import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';
import noop from 'utils/noop';

export const BottomLinks = () => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.bottomLinks}>
      <Pressable style={styles.linkContainer} onPress={noop}>
        <View style={styles.infoIconContainer}>
          <Icon variant="info" size="$4" />
        </View>
        <Text style={styles.linkText}>
          {formatMessage({ id: 'howItWorks', defaultMessage: 'How it works' })}
        </Text>
      </Pressable>
      <Pressable style={styles.linkContainer} onPress={noop}>
        <Text style={styles.linkText}>
          {formatMessage({ id: 'viewHistory', defaultMessage: 'View History' })}
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  bottomLinks: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: primitive.spacing.$4,
  },
  linkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  infoIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 20,
    borderRadius: 10,
    paddingRight: primitive.spacing.$1,
  },
  linkText: {
    paddingRight: primitive.spacing.$1,
    fontSize: primitive.fontSizes.xs,
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
});
